import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@contexts/AuthContext';
import { I18nProvider } from '@/i18n';
import App from './App';
import './index.css';

// StrictMode omitted: its double-invoke races the single-use refresh-token
// rotation (same reason as the admin app). The portal owns its subdomain, so
// basename is root unless VITE_BASE_PATH overrides it.
const basename = (import.meta.env.VITE_BASE_PATH || '/').replace(/\/$/, '') || '/';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter basename={basename}>
    <I18nProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </I18nProvider>
  </BrowserRouter>
);

// Register the service worker (installable PWA + offline shell). Ignored in
// dev where sw.js isn't served from root the same way.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* non-fatal */ });
  });
}
